import React from 'react';
import './index.less';
import { LazyLoadImage, LazyLoadImageProps } from 'react-lazy-load-image-component';

export type ImageProps = LazyLoadImageProps;

interface ImageProps2 extends ImageProps {
  className?: string;
  src?: string;
}
export class Image extends React.PureComponent<ImageProps2> {
  render(): React.ReactNode {
    const { props } = this;
    const placeholderSrc = 'https://p0.meituan.net/mtdxweb/84c34a348845a5d227d488c8aed7773e6809.jpg@25_78_750_422a';
    return <LazyLoadImage placeholderSrc={placeholderSrc} {...props} />;
  }
}
